var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 10,
  y: 12,
  width: 18,
  height: 2.6,
  rx: 1.3,
  fill: "#dfe6ec"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 6,
  y: 14,
  width: 30,
  height: 8,
  rx: 2,
  fill: "#3c4652"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 29,
  y: 15.8,
  width: 4.6,
  height: 2.2,
  rx: 0.7,
  fill: "#8fb6c9"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m12 22h16v8.5l-2.7-1.6-2.6 1.6-2.7-1.6-2.6 1.6-2.7-1.6-2.7 1.6z",
  fill: "#eef1f5"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m14.5 27 3-2.6 2.9 1.6 3.1-3",
  fill: "none",
  stroke: "#5a8fd8",
  strokeWidth: 1.2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 8.5,
  y: 22,
  width: 2.5,
  height: 13.5,
  fill: "#46626d"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 31,
  y: 22,
  width: 2.5,
  height: 13.5,
  fill: "#46626d"
});

var _ref9 = /*#__PURE__*/React.createElement("circle", {
  cx: 38.8,
  cy: 8,
  r: 5.6,
  fill: "#d84338"
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  x: 37.95,
  y: 4.6,
  width: 1.7,
  height: 4.4,
  rx: 0.85,
  fill: "#ffffff"
});

var _ref11 = /*#__PURE__*/React.createElement("circle", {
  cx: 38.8,
  cy: 10.9,
  r: 0.95,
  fill: "#ffffff"
});

function SvgPlotterIssue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 45 45",
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlotterIssue);
export default __webpack_public_path__ + "static/media/plotter-issue.751ea90001bbfed21e3671efb4d092db.svg";
export { ForwardRef as ReactComponent };